import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractConfirmationContentComponent } from '@pattern-library/onscreen-messaging/confirmation-dialog/abstract-confirmation-content-component';

@Component({
  selector: 'app-payment-reversal-confirmation',
  templateUrl: './payment-reversal-confirmation.component.html',
  styleUrls: ['./payment-reversal-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaymentReversalConfirmationComponent extends AbstractConfirmationContentComponent {}
